import type {ILogin} from "../types/ILogin";

export const loginFormDefaultValues: ILogin = {
    email: "",
    password: ""
};
